var Engagements = {
    currentItem: [],
    currentSelect: '',
    currentProperty: '',
    deleteId: '',
    newItemId: '',

    init: function () {
        Engagements.bindPupilSearch();
        Engagements.bindAddProperty();
        Engagements.bindCancel();
        Engagements.bindDelete();
        Engagements.bindManageEngagementsPropertyButtons();
        //Engagements.bindManageModal();
        //Engagements.toggleManageModal();
        Engagements.bindManagePropertySave();
        //Engagements.bindPropertySelect();
        Engagements.bindDeleteEngagementsImage();
    },

    bindPupilSearch: function() {
        $('#engagements-pupil-search').select2({
            ajax: {
                url: '/admin/pupils/ajax',
                placeholder: 'Search by Pupil Name',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        }).on('select2:select', function(e) {
            window.location.href = '/engagements?pupil=' + $(this).select2('data')[0].id;
        });
    },

    bindAddProperty: function() {
        $('.engagement-property-add').on('click', function(e) {
            var property = $(this).data('property');
            var name = $('#' + property).val();
            var translatedProperty = translatedLesson;
            Engagements.currentProperty = property;
            $.get('/engagements/' + property + '/add?name=' + name, function(data) {
                if (data.success) {
                    alert(translatedProperty + ' added successfuly!');
                    $('#' + property + '-modal').modal('hide');
                    Engagements.bindPropertySelect();
                } else {
                    alert('Action not successful, please try again.');
                }
            });
        });
    },

    bindCancel: function() {
        $('.delete-cancel').click(function() {
            Engagements.toggleManageModal(false);
        });
    },

    bindDelete: function() {
        $('.engagement-property-delete').click(function() {
            if (!$(this).hasClass('confirm')) {
                Engagements.toggleManageModal(true);
                return;
            }
            var originalId = Engagements.currentItem['id'];
            var property = Engagements.currentProperty;
            var newId = $('#manage-' + property + '-select').val();
            Engagements.newItemId = newId;
            var translatedProperty = translatedLesson;
            $.get('/engagements/' + property + '/delete-lesson?original_id=' + originalId + '&new_id=' + newId, function(data) {
                if (data.success) {
                    alert(translatedProperty + ' successfully deleted.');
                    $('#manage-' + property + '-modal').modal('hide');
                    Engagements.deletedId = originalId;
                    Engagements.bindPropertySelect();
                    return;
                }
                alert('Action not successful. Please try again.');
            })
        });
    },

    bindManageEngagementsPropertyButtons: function() {
        $('.manage-engagement-property').click(function() {
            var selectId = $(this).data('select');
            var property = $(this).data('property');
            Engagements.currentProperty = property;
            var translatedProperty = translatedLesson;
            Engagements.toggleManageModal(false);
            var typeSelect = $('#manage-' + property+ '-select');
            var propertyElement =  $('#manage-' + property + '-name');
            propertyElement.val('').attr('placeholder', 'New name');
            var select = $('#' + selectId);
            var option = select.find(':selected');
            Engagements.currentItem['id'] = option.val();
            Engagements.currentItem['name'] = option.text();
            $('#manage-' + property + '-title').html('Manage ' + translatedProperty + ': ' + Engagements.currentItem['name']);
            typeSelect.find('option').attr('disabled', false);
            typeSelect.find('option[value="' + Engagements.currentItem['id'] +'"]').attr('disabled', true);
        });
    },

    /*
    bindManageModal: function() {
        $('.engagement-property-modal').on('hidden.bs.modal', function() {
            Incidents.toggleManageModal();
        });
    },
    */

    toggleManageModal: function(remove) {
        var property = Engagements.currentProperty;
        var translatedProperty = translatedLesson;
        $('#manage-' + property + '-name').hide();
        if (remove) {
            var deleteBtn = $('#'+ property +'-delete');
            deleteBtn.removeClass('btn-secondary').addClass('btn-danger').addClass('confirm').html('<i class="fa fa-trash" aria-hidden="true"></i> Confirm');
            $('#' + property + '-delete-cancel').show();
            $('#manage-' + property + '-save').hide();
            return;
        }
        $('#' + property + '-delete').removeClass('btn-danger').addClass('btn-secondary').removeClass('confirm').html('<i class="fa fa-trash" aria-hidden="true"></i> Delete');
        $('#' + property + '-delete-text').html('').hide();
        $('#manage-' + property + '-select-container').slideUp('fast');
        $('#manage-' + property + '-name').slideDown('fast');
        $('#' + property + '-delete-cancel').hide();
        $('#manage-' + property + '-save').show();
    },

    bindManagePropertySave: function() {
        $('.engagement-property-save').click(function() {
            var property = Engagements.currentProperty;
            var nameInput = $('#manage-' + property + '-name');
            if (nameInput.val() != '') {
                var name = nameInput.val();
                var id = Engagements.currentItem['id'];
                var translatedProperty = translatedLesson;
                name = encodeURIComponent(name);
                $.get('/engagements/' + property + '/rename?id=' + id + '&name=' + name, function(res) {
                    if (res.success) {
                        alert(translatedProperty + ' updated successfully!');
                        nameInput.val('');
                        $('#manage-' + property +' -modal').modal('hide');
                        Engagements.bindPropertySelect();
                        return;
                    }
                    alert('Action not successful. Please try again.');
                });
            }
        });
    },

    bindPropertySelect: function () {
        var property = Engagements.currentProperty;
        var selects = $('#lesson-select');
        var url = '/engagements/lessons';
        var translatedProperty = translatedLesson + 's';
        $.get(url, function(propertyItems) {
            var manageSelect = $('#manage-'+ property +'-select');
            manageSelect.empty();
            propertyItems = App.sortProperties(propertyItems, false);
            for (var x = 0; x < selects.length; x++) {
                var select = $(selects[x]);
                var currentId = select.val();
                select.empty();
                var item = '<option value="" selected disabled>Click to see list of ' +  translatedProperty  + '</option>';
                select.append(item);
                for (var z = 0; z < propertyItems.length; z++) {
                    var selectOption = '';
                    var disabled = '';
                    var propertyItem = propertyItems[z];
                    if (propertyItem[0] == currentId || (Engagements.deletedId == currentId && propertyItem[0] == Engagements.newItemId)) {
                        selectOption = 'selected';
                        // disabled = 'disabled';
                    }
                    item = '<option value="'+ propertyItem[0] +'"' + selectOption + '>'+ propertyItem[1] +'</option>';
                    select.append(item);
                    // item = '<option value="'+ focusArea[0] +'"' + selectOption + ' ' + disabled + '>'+ focusArea[1] +'</option>';
                    if (x < 1) {
                        manageSelect.append(item);
                    }
                }
            }
            Engagements.deletedId = '';
        });
    },

    bindDeleteEngagementsImage: function() {
        $('.image-delete').click(function(e) {
            var btn = $(this);
            var remove = confirm('Are you sure you want to remove this file?');
            if (remove) {
                var fileId = btn.data('file');
                var key = btn.data('key');
                $.get('/engagements/' + fileId + '/image-delete?key=' + key, function(response) {
                    if (!response['success']) {
                        alert('Action failed. Please try again.');
                        return false;
                    }
                    alert('File successfully deleted.');
                    window.location.reload();
                });
            }
        });
    }

}
